export const paymentOptions = [
    "Visa/Master",
    "Nets",
    "Voucher Extension (Old serial number)",
    "Cash",
    "Voucher replacement (Old serial number)",
    "Service Recovery",
    "Partner Voucher Exchange",
    "Sponsorship",
    "Tourist Program",
    "Internet Banking",
    "Cheque",
    "Promo",
  ];